import { useEffect, useRef } from 'react'
import { Center, Stack, Title, Text, Loader, Anchor, Alert } from '@mantine/core'
import { Link } from 'react-router'
import { IconAlertCircle } from '@tabler/icons-react'
import { notifications } from '@mantine/notifications'
import { useLauncherStore } from '../../stores/launcherStore'
import { requestHandoff } from '../../api/launcherApi'
import { useState } from 'react'

export function RedirectView() {
  const { apps, lastOpenedAppId } = useLauncherStore()
  const launched = useRef(false)
  const [error, setError] = useState<string | null>(null)

  const targetApp = apps.find((a) => a.appId === lastOpenedAppId)

  useEffect(() => {
    if (launched.current || !lastOpenedAppId || !targetApp?.url) return
    launched.current = true

    requestHandoff(lastOpenedAppId)
      .then((token) => {
        window.location.href = `${targetApp.url}?handoff=${encodeURIComponent(token)}`
      })
      .catch(() => {
        notifications.show({ color: 'red', message: 'Could not launch application. Please try again.' })
        setError('Failed to launch the application.')
      })
  }, [lastOpenedAppId, targetApp])

  if (error) {
    return (
      <Center style={{ minHeight: 'calc(100vh - 100px)' }}>
        <Stack align="center" gap="md">
          <Alert icon={<IconAlertCircle size={16} />} color="red" title="Launch failed">
            {error}
          </Alert>
          <Anchor component={Link} to="/" size="sm">
            ← Back to apps
          </Anchor>
        </Stack>
      </Center>
    )
  }

  return (
    <Center style={{ minHeight: 'calc(100vh - 100px)' }}>
      <Stack align="center" gap="md">
        <Loader size="lg" />
        <Title order={3}>
          Redirecting you to {targetApp?.name ?? 'your application'}…
        </Title>
        <Text c="dimmed" size="sm">You'll be taken there in a moment.</Text>
        <Anchor component={Link} to="/" size="sm">
          ← Switch app
        </Anchor>
      </Stack>
    </Center>
  )
}
